import React, { useEffect } from 'react'
import ProfileSetup from './ProfileSetup'
import { DropDown } from '../../../commons'
import { CalenderIcon } from '../../../Icon'
import { Label } from 'reactstrap'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import { formatDate } from '../../../../utils/commonFunctions'
import { DropDownType, ProfileSetupDetailsType } from '../../../../commonTypes/clientDirectoryTypes'
import { getMonths } from '../../../commons/Gst'
import { monthsDropDown } from '../../../../constant/months'
type AppProps = {
    clientAadharUniqueCheckMessage: string | null;
    clientPanUniqueCheckMessage: string | null;
    profileSetupDetails: ProfileSetupDetailsType;
    setProfileSetupDetails: (data: any) => void;
    singleClientDirectory: any;
    handleClientDirectoryFormSubmit: () => void;
    handleGoBack: () => void;
    isDisabled?: boolean;
    isViewClientPresent?: boolean;
}
const ProfileSetupTab = ({
    clientAadharUniqueCheckMessage,
    clientPanUniqueCheckMessage,
    profileSetupDetails,
    handleClientDirectoryFormSubmit,
    handleGoBack,
    setProfileSetupDetails,
    singleClientDirectory,
    isDisabled,
    isViewClientPresent
}: AppProps) => {
    const option = [
        {
            value: "",
            label: "none"
        }
    ]
    const handleDateChange = (date: string, name: string) => {
        if (name === "clientFrom") {
            setProfileSetupDetails((prev: any) => {
                return {
                    ...prev,
                    clientHistory: {
                        ...prev.clientHistory,
                        clientFrom: date === "Invalid date" ? null : date
                    }
                }
            })
        }
        else if (name === "clientUntil") {
            setProfileSetupDetails((prev: any) => {
                return {
                    ...prev,
                    clientHistory: {
                        ...prev.clientHistory,
                        clientUntil: date === "Invalid date" ? null : date
                    }
                }
            })
        }
    }

    const handleProfileSetupDropDownChange = (data: DropDownType, name: string) => {
        if (name === "taxYear") {
            setProfileSetupDetails((prev: any) => {
                return {
                    ...prev,
                    profileSetup: {
                        ...prev.profileSetup,
                        taxYearEnd: {
                            value: data?.value,
                            label: data?.label
                        },
                    }
                }
            })
        }
        else if (name === "clientType") {
            setProfileSetupDetails((prev: any) => {
                return {
                    ...prev,
                    profileSetup: {
                        ...prev.profileSetup,
                        clientType: {
                            value: data?.value,
                            label: data?.label
                        },
                    }
                }
            })
        }
        else if (name === "subcategory") {
            setProfileSetupDetails((prev: any) => {
                return {
                    ...prev,
                    profileSetup: {
                        ...prev.profileSetup,
                        clientTypeSubcategory: {
                            value: data?.value,
                            label: data?.label
                        },
                    }
                }
            })
        }
    }

    const handleAccountsMonthChange = (data: DropDownType) => {
        setProfileSetupDetails((prev: any) => {
            return {
                ...prev,
                annualAccountsMonth: {
                    value: data?.value,
                    label: data?.label
                }
            }
        })
    }

    return (
        <div className='card'>
            <h5>Profile Setup</h5>
            <span className='mb-3'>Update your Profile details here</span>
            <ProfileSetup
                profileSetupDetails={profileSetupDetails?.profileSetup}
                handleProfileSetupDropDownChange={handleProfileSetupDropDownChange}
                setProfileSetupDetails={setProfileSetupDetails}
                isDisabled={isDisabled}
            />
            <p style={{ marginTop: "20px", marginBottom: "-1px", fontWeight: "500" }}>ANNUAL ACCOUNTS SCHEDULING</p>
            <div className='row'>
                <div className='col-md-3 mt-2 mb-3'>
                    <label htmlFor='Annual Accounts Month'>Annual Accounts Month</label>
                    <DropDown
                        // disabled
                        options={monthsDropDown}
                        value={profileSetupDetails?.annualAccountsMonth}
                        handleChange={handleAccountsMonthChange}
                        disabled={isDisabled}
                    />
                </div>
            </div>
            <p style={{ marginTop: "3px", fontWeight: "500" }}>CLIENT HISTORY</p>
            <div className='row mb-5'>
                <div className='col-md-12'></div>
                <div className="col-md-3">
                    <div className="form-group">
                        <div className='date-picker-wraper mr-0'>
                            <label>Client From</label>
                            <Label className='m-0 p-0 w-100'>
                                <DatePicker
                                    dateFormat="dd-MM-yyyy"
                                    selected={profileSetupDetails?.clientHistory?.clientFrom ? new Date(moment(`${profileSetupDetails?.clientHistory?.clientFrom}T00:00:00`, 'YYYY-MM-DD').format('YYYY-MM-DD[T]HH:mm:ss')) : null}
                                    onChange={(e: any) => { handleDateChange?.(moment(e).format('YYYY-MM-DD'), "clientFrom") }}
                                    fixedHeight
                                    showMonthDropdown
                                    showYearDropdown
                                    name='dateOfInvoice'
                                    placeholderText='Select'
                                    className='form-control'
                                     disabled={isDisabled}
                                // disabled
                                />
                                <span className="calender-icon" style={{ right: '30px', cursor: 'pointer', marginTop: "22px" }}>
                                    <CalenderIcon />
                                </span>
                            </Label>
                        </div>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="form-group">
                        <div className='date-picker-wraper mr-0'>
                            <label>Client Until</label>
                            <Label className='m-0 p-0 w-100'>
                                <DatePicker
                                    dateFormat="dd-MM-yyyy"
                                    selected={profileSetupDetails?.clientHistory?.clientUntil
                                        ? new Date(moment(`${profileSetupDetails?.clientHistory?.clientUntil}T00:00:00`, 'YYYY-MM-DD').format('YYYY-MM-DD[T]HH:mm:ss')) : null}
                                    onChange={(e: any) => { handleDateChange?.(moment(e).format('YYYY-MM-DD'), "clientUntil") }}
                                    fixedHeight
                                    showMonthDropdown
                                    showYearDropdown
                                    name='dateOfInvoice'
                                    placeholderText='Select'
                                    className='form-control'
                                    disabled={!profileSetupDetails?.clientHistory?.clientFrom||isDisabled}
                                    minDate={profileSetupDetails?.clientHistory?.clientFrom ? new Date(moment(`${profileSetupDetails?.clientHistory?.clientFrom}T00:00:00`, 'YYYY-MM-DD').format('YYYY-MM-DD[T]HH:mm:ss')) : null}
                                />
                                <span className="calender-icon" style={{ right: '30px', cursor: 'pointer', marginTop: "22px" }}>
                                    <CalenderIcon />
                                </span>
                            </Label>
                        </div>
                    </div>
                </div>
            </div>
            <hr></hr>
            <div className='row'>
                <div className='col-md-12 text-right'>
                    <button  className={isViewClientPresent?"btn-primary btn":"btn" } style={{ border: "1px solid #bfcbe1", marginRight: '15px' }}
                        onClick={() => handleGoBack()}
                    >{isViewClientPresent ? "Back" : "Cancel"}</button>
                   {!isViewClientPresent? <button className='btn btn-primary'
                        disabled={clientPanUniqueCheckMessage?.includes("PAN number already exists") || clientAadharUniqueCheckMessage?.includes("Aadhaar number already exists")}
                        onClick={handleClientDirectoryFormSubmit}
                    >{singleClientDirectory ? "Save Changes" : "Save"}</button>:""}
                </div>
            </div>
        </div>
    )
}

export default ProfileSetupTab